<template>
	<div id="profile" class='gcardfr'>
		<el-form :model="pform" style="width: 70%;margin:0 auto;">
			<el-form-item :label="$t('app_login_account')" :label-width="cwidth">
				<div class="pslb">{{profile.userId?profile.userId:'null'}}</div>
			</el-form-item>
			<el-form-item :label="$t('app_nick_name')" :label-width="cwidth">
				<div class="pslb">{{profile.nickName?profile.nickName:'null'}}</div>
			</el-form-item>
			<el-form-item :label="$t('app_phone_number')" :label-width="cwidth">
				<div class="pslb">{{profile?profile.phone:''}}</div>
			</el-form-item>
			<el-form-item :label-width="cwidth">
				<el-button type="primary" @click="modify">{{ $t('app_modify_data') }}</el-button>
				<el-button @click="showCp = true">{{ $t('app_change_password') }}</el-button>
			</el-form-item>
		</el-form>

		<el-dialog class='gstdia' :title="$t('app_modify_data')" :visible.sync="showMd" @close='closeMd'>
			<el-form :model="mdform" v-loading='loading'>
				<el-form-item :label="$t('app_nick_name')" :label-width="$formlbWidth">
					<el-input v-model="mdform.nick" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_phone_number')" :label-width="$formlbWidth">
					<el-input v-model="mdform.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeMd">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="!mdform.nick || !mdform.phone" type="primary" @click="mdRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog class='gstdia' :title="$t('app_change_password')" :visible.sync="showCp">
			<el-form :model="mpform" @close='closeCp' v-loading='loading'>
				<el-form-item :label="$t('app_current_password')" :label-width="$formlbWidth">
					<el-input v-model="mpform.psw" autocomplete="off" show-password>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('app_new_password')" :label-width="$formlbWidth">
					<el-input v-model="mpform.newpsw" autocomplete="off" show-password>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('app_new_password_2')" :label-width="$formlbWidth">
					<el-input v-model="mpform.cfpsw" autocomplete="off" show-password>
					</el-input>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeCp">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="cpdis" type="primary" @click="cpRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<style>
	#profile {
		text-align: center;
	}

	.pslb {
		width: 100%;
		color: rgba(0, 0, 0, 0.65);
		border-bottom: 1px solid rgba(0, 0, 0, 0.15);
	}
</style>


<script>
	var md5 = require('md5')
	export default {
		data() {
			return {
				loading: false,
				showMd: false,
				showCp: false,
				pform: {},
				mdform: {
					nick: '',
					phone: ''
				},
				mpform: {
					psw: '',
					newpsw: '',
					cfpsw: ''
				},
				cwidth: '120px'
			}
		},
		computed: {
			profile() {
				var pf = this.getUsr()
				if (pf) {
					return pf
				} else {
					return {}
				}
			},
			cpdis() {
				var form = this.mpform
				if (form.psw && form.newpsw && form.cfpsw) {
					return false
				} else {
					return true
				}
			}
		},
		methods: {
			getUsr() {
				return this.$getTmp('user')
			},
			closeCp() {
				this.mpform.psw = ''
				this.mpform.newpsw = ''
				this.mpform.cfpsw = ''
				this.showCp = false
			},
			cpRqs() {
				var fm = this.mpform
				if (fm.newpsw !== fm.cfpsw) {
					this.$message.error(this.$t("app_pasword_error"))
					return
				}

				var p = this.profile
				this.loading = true
				this.$mdUsrPsw(p.userId, md5(fm.psw), md5(fm.cfpsw), res => {
					this.loading = false
					if (res.status == 200) {
						this.$logout(this)
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			mdRqs() {
				var pf = this.profile
				var fm = this.mdform

				this.loading = true
				this.$mdProfile(pf.userId, fm.nick, fm.phone, res => {
					this.loading = false
					if (res.status == 200) {
						pf.nickName = fm.nick
						pf.phone = fm.phone
						this.$setTmp('user', pf)
						location.reload()
						// this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})


			},
			modify() {
				this.mdform.nick = this.profile ? this.profile.nickName : ''
				this.mdform.phone = this.profile ? this.profile.phone : ''
				this.showMd = true
			},
			closeMd() {
				this.showMd = false
				this.mdform.nick = ''
				this.mdform.phone = ''
			}
		},
		// mounted () {
		// }
	}
</script>
